import * as AvatarPrimitive from '@radix-ui/react-avatar'
import { cn, initials } from '@/lib/utils'

interface AvatarProps {
  name: string
  imageUrl?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'h-7 w-7 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-11 w-11 text-base',
}

export function Avatar({ name, imageUrl, size = 'md', className }: AvatarProps) {
  return (
    <AvatarPrimitive.Root className={cn('relative flex shrink-0 overflow-hidden rounded-full', sizeClasses[size], className)}>
      {imageUrl && (
        <AvatarPrimitive.Image src={imageUrl} alt={name} className="aspect-square h-full w-full object-cover" />
      )}
      <AvatarPrimitive.Fallback className="flex h-full w-full items-center justify-center bg-brand-100 text-brand-700 font-semibold">
        {initials(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  )
}
